export default __webpack_public_path__ + "static/media/otpback.1fdb656e.svg";